import { Component, Inject } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '@src/environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-page-resend-welcome-emails',
    templateUrl: './resend-welcome-emails.component.html'
})
export class ResendWelcomeEmailsComponent  {
    uploaderUsernames: FileUploader;

    constructor(@Inject('AuthService')
        private router: Router,
        private oAuthservice: OAuthService,
        private toastrService: ToastrService) {
    }

    ngOnInit(): void {
        this.uploaderUsernames = new FileUploader({
            removeAfterUpload: true,
            autoUpload: true,
            url: environment.apiBaseUrl + '/api/users/resendwelcomeemails'
        });
        this.uploaderUsernames.onBeforeUploadItem = () => {
            this.uploaderUsernames.authToken = 'Bearer ' + this.oAuthservice.getAccessToken();
        };

        this.uploaderUsernames.onCompleteItem = (item, response) => {
            if (item.isSuccess) {
                this.toastrService.success('Usernames file uploaded successfully');
            }
            else {
                this.toastrService.error('Upload error');
            }
        };
    }
  
    gotoUsers() {
        this.router.navigate([`users`]);
    }
}
